module.exports = __webpack_public_path__ + "40edc9bec8f0ee0b1e14a5e86ab99e9a.png";